import axios from "axios";
import enviroments from "@app/config/enviroments";

const api = axios.create({
  baseURL: enviroments.baseURL,
});

export default api;
